<template>
  <content-panel>
    <template v-slot:search>
      <search-box class="search-box">
        <el-form :inline="true" size="mini" label-width="100px" :model="searchForm" :rules="rules" ref="searchForm">
          <el-form-item label="产品编码" prop="productCode">
            <el-input v-model.trim="searchForm.productCode" @keyup.enter.native="onSearch" />
          </el-form-item>
          <el-form-item label="产品名称" prop="productName">
            <el-input v-model.trim="searchForm.productName" @keyup.enter.native="onSearch" />
          </el-form-item>
          <el-form-item label="文件名" prop="fileName">
            <el-input v-model.trim="searchForm.fileName" @keyup.enter.native="onSearch" />
          </el-form-item>
          <el-form-item label="类型" prop="uploadType">
            <el-select v-model="searchForm.uploadType" filterable clearable @change="onSearch">
              <el-option label="全部" value="" />
              <el-option v-for="item in ['普通', '京东', '天猫', '其他']" :label="item" :key="item" :value="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="上传来源" prop="uploadSource">
            <el-select v-model="searchForm.uploadSource" filterable clearable @change="onSearch">
              <el-option label="全部" value="" />
              <el-option v-for="item in ['渲染上传', '手动上传']" :label="item" :key="item" :value="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="上传时间:">
            <form-date-range :form="searchForm" startKey="dts" :usingTime="false" endKey="dte" valueFormat="yyyy-MM-dd">
            </form-date-range>
          </el-form-item>
        </el-form>
        <template v-slot:right>
          <el-button class="green-btn" size="mini" @click="onSearch">搜索</el-button>
          <el-button class="orange-btn" size="mini" @click="reset">重置</el-button>
        </template>
      </search-box>
    </template>

    <table-panel ref="tablePanel">
      <template v-slot:header-right>
        <el-button type="primary" size="mini" @click="exportExcel">导出</el-button>
      </template>
      <el-table
        stripe
        border
        ref="tableRef"
        :header-cell-style="{ backgroundColor: '#F4F8FB' }"
        highlight-current-row
        :data="tableData.list"
        :height="maxTableHeight"
        v-if="tableReload"
        v-loading="loading"
      >
        <el-table-column prop="spuCode" label="预览图" width="80" align="center">
          <template slot-scope="{row}">
            <el-button v-if="row.fileUrl" size="mini" type="text" @click="viewImg(row)">查看</el-button>
          </template>
        </el-table-column>
        <el-table-column prop="productCode" label="产品编码" min-width="100"></el-table-column>
        <el-table-column show-overflow-tooltip prop="productName" label="产品名称" min-width="180"></el-table-column>
        <el-table-column prop="fileName" label="文件名" min-width="100"></el-table-column>
        <el-table-column prop="uploadType" label="类型" min-width="80"></el-table-column>
        <el-table-column prop="createdDate" label="上传时间" min-width="140" sortable="custom"></el-table-column>
        <el-table-column prop="uploadUser" label="上传人" min-width="80"></el-table-column>
        <el-table-column prop="fileSize" label="大小" min-width="120"></el-table-column>
        <el-table-column prop="uploadSource" label="上传来源" min-width="80"></el-table-column>
        <el-table-column label="操作" fixed="right" align="center" width="100">
          <template slot-scope="{ row }">
            <el-button type="text" v-copy="row.filePath">复制地址</el-button>
          </template>
        </el-table-column>
      </el-table>
      <template v-slot:footer>
        <div style="text-align: right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.pageNum"
            :page-sizes="[30, 60, 90]"
            :page-size="tableData.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            background
            :total="tableData.total"
          ></el-pagination>
        </div>
      </template>
    </table-panel>
    <!-- 查看图片弹窗 -->
    <el-dialog title="图片查看" :visible.sync="imgFormVisible" :close-on-click-modal="false" width="50%" v-esc-close><imgShow :imgList="imgList"></imgShow></el-dialog>
  </content-panel>
</template>

<script>
import tableMixin from '@/utils/tableMixin';
import pagePathMixin from '@/utils/page-path-mixin'
import axios from '@/utils/axiosInstance';
import imgShow from '@/views/components/imgShow';
import { downloadFile } from '@/utils';
import moment from 'moment';
export default {
  name: 'photographySalaryAccounting',
  mixins: [tableMixin, pagePathMixin],
  components: { imgShow },
  data() {
    return {
      loading: false,
      tableData: {
        list: [],
        pageNum: 1,
        pageSize: 30,
        total: 0,
      },
      tableReload: true,
      imgFormVisible: false,
      searchFormData: [],
      rules: {},
      columnData: [],
      imgList: [],
      loading: false,
      searchForm: {
        productCode: '',
        productName: '',
        fileName: '',
        uploadType: '',
        uploadSource: '',
        dts: '',
        dte: '',
      },
      exportData: {},
    };
  },
  computed: {},
  methods: {
    onSearch() {
      this.tableData.pageNum = 1;
      this.init();
    },
    async init() {
      this.loading = true;
      let data = {
        pageNum: this.tableData.pageNum,
        pageSize: this.tableData.pageSize,
        filterData: this.searchForm,
      };
      this.searchFormData = data;
      this.$q.newProduct
        .productModelPageQuery({ data: data })
        .then((res) => {
          if (res.code == 200) {
            this.tableData = res.data;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 分页器 pagesize
    handleSizeChange(val) {
      this.tableData.pageSize = val;
      this.tableData.pageNum = 1;
      this.init();
    },
    // 分页器 pageNum
    handleCurrentChange(val) {
      this.tableData.pageNum = val;
      this.init();
    },

    reset() {
      this.searchForm = {
        productCode: '',
        productName: '',
        fileName: '',
        uploadType: '',
        uploadSource: '',
        dts: '',
        dte: '',
      },
      this.tableData.pageNum = 1;
      this.onSearch();
    },

    // 查看图片
    viewImg(row) {
      this.imgFormVisible = true;
      this.imgList = [row.fileUrl]
    },

    // 导出
    exportExcel() {
      console.log(this.searchFormData);
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      });
      let params = {
        appCode: 'ec-pc-new',
        // paramMap: this.searchFormData.filterData,
        paramMap: {
          ...this.searchFormData.filterData,
        },
        reportName: 'productModelExport',
      };
      this.$q.common.exportExcel({ data: params }).then((res) => {
        if (res.success) {
          this.$message.success('提交下载任务成功，请稍后到导出列表查阅！');
          loading.close();
        } else {
          this.$message.error(res.message);
        }
      });
    },
  },
  filters: {
    cellValFormat(val) {
      if (val) {
        return val;
      } else {
        if (isNaN(val) || val == 0) {
          return val;
        } else {
          return '--';
        }
      }
    },
  },
  mounted() {
    this.onSearch();
  },
};
</script>

<style lang="stylus" scoped>
.search-box
  >>> .el-date-editor.el-input__inner, >>> .el-select, >>> .el-input
    width 240px !important
>>> .date-range .single-date
  width 110px !important

>>> .form-number-input .el-input-number {
    width: 105px !important;
}
>>> .form-number-input .el-input-number .el-input {
    width: 105px !important;
}
</style>
